<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.hotWord')"
    resource="hot_words"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/hot_words.js';

@Component
export default class HotWords extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'name_cont',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'name',
      'position',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'name',
      'position',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'hot_words.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'hot_words.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/hot_words',
    name: 'hot_words.index',
    component: HotWords,
    props: {
      type: 'index',
    }
  },
  {
    path: '/hot_words/new',
    name: 'hot_words.new',
    component: HotWords,
    props: {
      type: 'new',
    }
  },
  {
    path: '/hot_words/:id',
    name: 'hot_words.show',
    component: HotWords,
    props: {
      type: 'show',
    }
  },
  {
    path: '/hot_words/:id/edit',
    name: 'hot_words.edit',
    component: HotWords,
    props: {
      type: 'edit'
    }
  }
]
</script>
